import React from 'react';
import styled from '@emotion/styled';
import breakpoints from './Theme/breakpoints';
import KeyboardArrowDownRounded from './Icons/KeyboardArrowDownRounded';

const ReadMoreWrapper = styled.div<{ isHidden: boolean }>`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100vw;
  display: ${(properties) => (properties.isHidden
    ? 'none'
    : 'flex'
  )};
  opacity: ${(properties) => (properties.isHidden
    ? 0
    : 1
  )};
  transition: display 0s, opacity 0.5s ease-out;
  height: auto;
  justify-content: center;
  font-size: 4rem;
  @media(min-width: ${breakpoints.sm}px) {
    display: none;
  }
`;

const ReadMoreArrow = (
  {
    onClick,
    isHidden,
  }: {
    onClick: () => void;
    isHidden: boolean;
  },
) => (
  <ReadMoreWrapper
    onClick={onClick}
    isHidden={isHidden}
  >
    <KeyboardArrowDownRounded
      color="primary"
      fontSize="inherit"
      titleAccess="Scroll down to read more"
    />
  </ReadMoreWrapper>
);

export default ReadMoreArrow;
